var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"utilities_page",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"status_list"},_vm._l((_vm.utilities_list),function(utility,key){return _c('UtilitiesItem',{key:key,staticClass:"setting-item",attrs:{"utility":utility}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }